module.exports = __webpack_public_path__ + "static/media/thermometer-quarter.385f39ed.svg";